var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Nav'),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"xs":24,"sm":24,"md":16,"lg":16,"xl":16}},[_c('Calendar')],1),_c('el-col',{attrs:{"xs":24,"sm":24,"md":8,"lg":8,"xl":8}},[_c('Timer')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }